module.exports = __webpack_public_path__ + "static/media/menu-cat-background.2a3329ed.jpg";